import { render, staticRenderFns } from "./Baccarat.vue?vue&type=template&id=2196b988&scoped=true"
import script from "./Baccarat.vue?vue&type=script&lang=js"
export * from "./Baccarat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2196b988",
  null
  
)

export default component.exports